import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Header } from 'foundations-components/transitional/components/Header';
import SettingsPage from 'settings-ui-nav/SettingsPage';
import AlertsContainer from './AlertsContainer';
import UserPreferencesSidebar from './UserPreferencesSidebar';
import TwoFactorSetupReturnBackTo from '../components/TwoFactorSetupReturnBackTo';
import { isApplicationHubless } from '../selectors/AuthSelector';
import { tracker } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class UserPreferences extends Component {
  componentDidMount() {
    const {
      location,
      history
    } = this.props;
    history.push(`/profile${location.search}`);
  }
  renderBody() {
    const {
      children,
      isHubless
    } = this.props;
    if (isHubless) {
      return /*#__PURE__*/_jsxs(ListingPage, {
        headerComponent: /*#__PURE__*/_jsx(Header, {}),
        sidebarComponent: /*#__PURE__*/_jsx(UserPreferencesSidebar, {}),
        title: I18n.text('userPreferences.profilePreferences'),
        children: [/*#__PURE__*/_jsx(NotificationList, {}), children]
      });
    }
    return /*#__PURE__*/_jsxs(SettingsPage, {
      pathname: window.location.pathname,
      track: tracker.track,
      children: [/*#__PURE__*/_jsx(NotificationList, {}), children]
    });
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(AlertsContainer, {}), /*#__PURE__*/_jsx(TwoFactorSetupReturnBackTo, {}), this.renderBody()]
    });
  }
}
UserPreferences.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  isHubless: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    isHubless: isApplicationHubless(state)
  };
};
export default withRouter(connect(mapStateToProps)(UserPreferences));